import {
    Button,
    Element,
    Icon,
    RouterLink,
} from '@zmedia/bm-soccer-ui/components';
import cn from 'classnames';
import { memo, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { useOutsideClick } from '@zmedia/bm-soccer-ui/hooks';
import styles from './style.module.scss';

export function SelectRound({
    listRound,
    currentRound,
    url,
    isReverse,
}: {
    listRound: string[];
    currentRound: number;
    url: string;
    isReverse?: boolean;
}) {
    const router = useRouter();
    const [open, toggleOpen] = useState<boolean>(false);
    const selectRef = useRef(null);
    const handleClickOutside = (isInside: boolean) => {
        if (!isInside) {
            setTimeout(() => toggleOpen(false), 100);
        }
    };

    useOutsideClick(selectRef, handleClickOutside);

    const renderRound = (item: string, index: number, isReverse: boolean) => {
        const seasonId = router.query.seasonId;
        const roundUrl = isReverse ? listRound.length - index : index + 1;
        return (
            <RouterLink
                to={`${url}/?round=${roundUrl}${
                    seasonId ? `&seasonId=${seasonId}` : ''
                }`}
                className={cn(styles['round-item'], {
                    [styles['is-select']]: isReverse
                        ? index === listRound.length - currentRound
                        : index === currentRound - 1,
                })}
                key={index}
            >
                <Element className={styles['select-text']}>{item}</Element>
            </RouterLink>
        );
    };

    const renderRounds = (rounds: string[], isReverse: boolean = false) => {
        const _rounds = isReverse ? [...rounds].reverse() : [...rounds];
        return _rounds?.map((round: string, index: number) => {
            return renderRound(round, index, isReverse);
        });
    };

    return (
        <Element className={styles['select-round']}>
            <Button
                className={styles['btn-select']}
                onClick={() => toggleOpen(!open)}
                domRef={selectRef}
            >
                {listRound[currentRound - 1]}
                {listRound.length > 0 && (
                    <Icon icon={open ? 'up' : 'down'}></Icon>
                )}
            </Button>

            {open && listRound.length > 0 && (
                <Element className={styles['round-items']}>
                    {renderRounds(listRound, isReverse)}
                </Element>
            )}
        </Element>
    );
}

export default memo(SelectRound);
